module.exports = __webpack_public_path__ + "static/media/candidateWelcome.75026d17.png";